import { MessageDescriptor } from 'react-intl';
import documentsAreaMessages from '../../../messages/documents-area/documents-area.messages';
import {
  DocumentsAreaSections,
  DocumentsTableType,
  DocumentType,
} from '../../../model';

export const labelForDocumentsAreaSection = (
  section: DocumentsAreaSections
): MessageDescriptor => {
  switch (section) {
    case 'DOCUMENTS':
      return documentsAreaMessages.documentTab;
    case 'INFO_OFFER':
      return documentsAreaMessages.informationOfferTab;
    case 'COMMUNICATIONS':
      return documentsAreaMessages.communicationsTab;
    default:
      return {
        id: section,
        defaultMessage: section,
      };
  }
};

export const labelForDocumentsChip = (
  documentType: DocumentType
): MessageDescriptor => {
  switch (documentType) {
    case 'Contract':
      return documentsAreaMessages.contractItem;
    case 'Disposition':
      return documentsAreaMessages.dispositionsItem;
    case 'ExpiredDocuments':
      return documentsAreaMessages.expiredDocumentsItem;
    default:
      return {
        id: documentType,
        defaultMessage: documentType,
      };
  }
};

export const labelForDocumentsTableCard = (
  documentTableType: DocumentsTableType
): MessageDescriptor | undefined => {
  const { documentsType, section } = documentTableType;
  if (section === 'DOCUMENTS') {
    return labelForDocumentsChip(documentsType as DocumentType);
  } else {
    return undefined;
  }
};
